import React from 'react'
import PropTypes from 'prop-types'

import { ContainedWrapMain } from './index.style'

const ContainedWrap = ({ children, center, size }) => {
  return <ContainedWrapMain center={center} size={size}>{children}</ContainedWrapMain>
}

ContainedWrap.propTypes = {
  center: PropTypes.bool,
  size: PropTypes.number.isRequired,
}

ContainedWrap.defaultProps = {
  center: true,
}

export default ContainedWrap
